<template>
  <v-row justify="center">
    <v-dialog v-model="userInfoActive" persistent max-width="400" v-if="currentUser">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("card.user-info") }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <div class="circular_image">
                <img
                  :alt="currentUser ? currentUser.nama : 'User'"
                  :src="currentUser ? currentUser.avatar_path : ''"
                />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <table class="user-info-table">
                <tr>
                  <td width="120px">{{ $t("label.name") }}</td>
                  <td width="10px" class="text-center">:</td>
                  <td>{{ currentUser.nama }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.nik") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nik }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.nik-sap") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nik_sap }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.cellphone") }}</td>
                  <td class="text-center">:</td>
                  <td style="font-weight:bold;">
                  {{ currentUser.nomor_ponsel }}
                  <span @click="showUpdateCellphone" class="change-cellphone">Update</span>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("label.job-title") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nama_jabatan }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.department-name") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nama_bagian }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.unit-name") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nama_unit }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.upline name") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ currentUser.nama_atasan }}</td>
                </tr>
                <tr>
                  <td>{{ $t("label.elemen pic") }}</td>
                  <td class="text-center">:</td>
                  <td>{{ elemenPic.nama_pic }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <!-- dibuka di tab baru agar user bisa membaca Pemberitahuan Privasi kapan saja -->
              <router-link :to="{ name: 'privacy-notice' }" target="_blank" rel="noopener" class="privacy-notice-link">
                <v-icon small color="primary" class="mr-1">{{ iconShield }}</v-icon>
                {{ $t("label.privacy-notice") }}
                <v-icon x-small color="primary" class="ml-1">{{ iconOpenNew }}</v-icon>
              </router-link>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeMe">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
import { mdiOpenInNew, mdiShieldCheckOutline } from "@mdi/js";
export default {
  props: {
    userInfoActive: Boolean,
    elemenPic:[Object,String],
  },
  data: () => ({
    iconOpenNew: mdiOpenInNew,
    iconShield: mdiShieldCheckOutline,
  }),
  computed: {
    ...mapState(["currentLanguage"]),
    ...mapState("user", ["currentUser"]),
  },
  methods: {
    closeMe() {
      this.$emit("closeUserInfo", false);
    },
    isSecretary(val) {
      let retVal = "False";
      if (!val) {
        this.currentLanguage == "id" ? (retVal = "Bukan") : (retVal = "No");
      } else {
        this.currentLanguage == "id" ? (retVal = "Ya") : (retVal = "Yes");
      }
      return retVal;
    },
    parseElemen(val){
      let result = 'STAFSUBAG/ASISTEN';
      switch (val) {
        case 'KARPIM':
        case 'KARPIM_KANPUS':
          result = 'STAFSUBAG/ASISTEN';
          break;
        case 'KASUBAG':
          result = 'KASUBAG/KABID/KASUBDIV/ASKEP/MASKEP';
          break;
        case 'PJP':
        case 'PJP_KANPUS':
          result = 'KABAG/KADIV/MANAGER';
          break;
        case 'DIREKTUR':
          result = 'DIREKTUR/SEVP';
          break;
        case 'KOMISARIS':
          result = 'DIREKTUR/SEVP/KOMISARIS';
          break;
        default:
          break;
      }
      return result;
    },
    showUpdateCellphone() {
       this.$emit("showUpdateCellphone");
    }
  },
};
</script>
<style>
.user-info-table td,.user-info-table th {
  padding: 2px 3px;
}
.change-cellphone {
  text-decoration: none;
  color: rgb(238, 134, 16);
  cursor: pointer;
}
.change-cellphone:hover {
  text-decoration: underline;
  text-underline-offset: 2px; /* opsional, bikin jarak dari teks */
}
.privacy-notice-link {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  text-decoration: none;
}
.privacy-notice-link:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>